import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Eyebrow, Reveal, Rich } from "./Motion";
import { scrollToId } from "./SmoothScroll";

const ServiceRow = ({ item, i }) => (
  <Reveal delay={i * 0.05}>
    <button data-testid={`service-row-${i}`} onClick={() => scrollToId("contact")}
      className="group relative w-full text-left grid grid-cols-12 gap-4 py-8 lg:py-10 px-2 lg:px-4 border-b border-[rgba(16,16,20,0.12)] overflow-hidden">
      <span className="absolute inset-0 bg-[var(--amber)] origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-[cubic-bezier(0.76,0,0.24,1)]" />
      <span className="relative col-span-2 lg:col-span-1 mono text-[12px] text-[var(--fux)] group-hover:text-[var(--ink)] pt-2 transition-colors duration-300">/0{i + 1}</span>
      <h3 className="relative col-span-10 lg:col-span-5 text-2xl lg:text-4xl font-bold tracking-[-0.02em] group-hover:text-[var(--ink)] transition-colors duration-300">{item.t}</h3>
      <p className="relative col-span-10 col-start-3 lg:col-start-auto lg:col-span-5 text-[rgba(16,16,20,0.72)] group-hover:text-[rgba(16,16,20,0.85)] transition-colors duration-300 lg:pt-1.5">{item.d}</p>
      <span className="relative hidden lg:flex col-span-1 justify-end pt-1"><ArrowUpRight className="w-7 h-7 group-hover:text-[var(--ink)] group-hover:rotate-45 transition-transform duration-500" /></span>
    </button>
  </Reveal>
);

const Strip = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <Reveal className="mt-16 lg:mt-24">
      <div ref={ref} data-testid="services-strip" className="relative h-[300px] lg:h-[440px] overflow-hidden rounded-t-[999px] rounded-b-[6px] shadow-[0_40px_80px_-40px_rgba(16,16,20,0.35)]">
        <motion.img style={{ y }} src="/img/consult.jpg" alt="Consulenza aziendale internazionale" className="absolute inset-0 w-full h-[125%] -top-[12%] object-cover" />
        <div className="absolute inset-0 bg-[#16265c]/25" />
        <div className="absolute inset-x-0 bottom-0 p-6 lg:p-8 flex justify-center">
          <span className="mono text-[11px] lg:text-[12px] uppercase bg-[#16265c]/75 backdrop-blur text-[var(--bone)] px-4 py-2 rounded-sm">CONSULENZA · DOCUMENTI · MERCATI · LOGISTICA</span>
        </div>
      </div>
    </Reveal>
  );
};

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-40 bg-[var(--paper)]">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14 lg:mb-20">
          <div className="lg:col-span-7">
            <Eyebrow className="!text-[#b08d1f] [&>span]:!bg-[#b08d1f]">{t.services.eyebrow}</Eyebrow>
            <Reveal><h2 data-testid="services-title" className="mt-8 display text-4xl sm:text-5xl lg:text-6xl leading-[1.06] tracking-[-0.01em]"><Rich text={t.services.title} /></h2></Reveal>
          </div>
          <Reveal delay={0.15} className="lg:col-span-4 lg:col-start-9 self-end"><p className="text-base lg:text-lg text-[rgba(16,16,20,0.75)] leading-relaxed">{t.services.intro}</p></Reveal>
        </div>
        <div className="border-t border-[rgba(16,16,20,0.12)]">
          {t.services.items.map((item, i) => <ServiceRow key={i} item={item} i={i} />)}
        </div>
        <Strip />
      </div>
    </section>
  );
};
